module.exports = __webpack_public_path__ + "img/group25@2x-韩语.e5e99654.png";